<mat-toolbar>Edit Category</mat-toolbar>
<div class="Dialog-body">
  <form>
    
    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input matInput type="text" [(ngModel)]="selectedName" [ngModelOptions]="{standalone: true}" matInput placeholder="Name">
    </mat-form-field>

    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input matInput type="text" [(ngModel)]="selectedDescription" [ngModelOptions]="{standalone: true}" matInput placeholder="Description">
    </mat-form-field>

      <div class="buttonbelow">
        <button mat-raised-button (click)="DialogClose()">Cancel</button>  
        <button mat-raised-button (click)="UpdateCategory()">Submit</button>
         
      </div>
  </form>

</div>
